import React from 'react';

/**
 * Component to show a validation error for a form input component.
 *
 * @param error the error message
 * @return the created {@link JSX.Element}.
 * @constructor
 */
export function ValidationErrorMessage({
  id,
  error
}: Readonly<{
  id: string;
  error: string;
}>): JSX.Element {
  return (
    <div className="error-message" id={id}>
      {error}
    </div>
  );
}
